export const PERSON_FORM_FIELDS = {
  ORGANIZATIONS: 'organizations',
  ORGANIZATION_NAME: 'organizationName',
  TYPES: 'types',
  CUSTOM_TYPES: 'customTypes',
};
export const PERSON_LOCATION_TYPES_FLIGHT = ['TRIP_AIR'];

export const TRAVEL_SEARCH_DATE_RANGE = 'travelSearchDateRange';
export const TRAVEL_SEARCH_DATE_RANGE_OPTIONS = 'dateRangeOptions';
export const TRAVEl_SEARCH_LOCATIONS = 'locationIds';
export const TRAVEl_SEARCH_LOCATION_TYPES = 'personLocationTypes';
export const TRAVEL_SEARCH_ORGS = 'organizationIds';
export const TRAVEL_SEARCH_LOCATION_RATINGS_ENABLED = 'locationRatingsEnabled';
export const TRAVEL_SEARCH_LOCATION_RATINGS = 'locationRatingRange';
export const TRAVEL_SEARCH_DESTINATION_TYPE = 'itineraryInternational';
export const TRAVEL_SEARCH_RECORD_LOCATOR = 'itineraryRecordLocatorLike';
export const TRAVEL_SEARCH_TRIP_STATUS = 'itineraryStatuses';
// DEPRECATED (HZFE_139): Remove the following when feature toggle is removed
export const TRAVEL_SEARCH_FLIGHT_NUMBER_LIKE = 'flightNumberLike';
export const TRAVEL_SEARCH_FLIGHT_NUMBERS = 'flightNumbers';
// DEPRECATED (HZFE_139): Remove the following when feature toggle is removed
export const TRAVEL_SEARCH_AIRLINE_ID = 'airlineId';
export const TRAVEL_SEARCH_AIRLINE_IDS = 'airlineIds';
export const TRAVEL_SEARCH_HOTEL_NAME = 'hotelNameLike';
export const TRAVEL_SEARCH_CAR_RENTAL = 'carRentalNameLike';
export const TRAVEL_SEARCH_TRIP_NAME = 'itineraryNameLike';
export const TRAVEL_SEARCH_TRIP_NOTES = 'itineraryNotesLike';
export const TRAVEL_SEARCH_TRAVEL_MNGMT_COMPANY = 'travelManagementCompanyLike';
export const TRAVEL_SEARCH_BOOKING_COUNTRIES = 'bookingCountryIds';
export const TRAVEL_SEARCH_EXPATRIATION_NAME = 'expatriationNameLike';
export const TRAVEL_SEARCH_SHOW_DELETED_ITINERARIES = 'itineraryDeletedStatuses';
export const TRAVEL_SEARCH_SHOW_DELETED_EXPATRIATIONS = 'expatriationDeletedStatuses';
export const TRAVEL_SEARCH_QUICK_SEARCH_TEXT = 'travelDataQuickSearchText';
export const TRAVEL_SEARCH_FIRST_NAME = 'firstNameLike';
export const TRAVEL_SEARCH_LAST_NAME = 'lastNameLike';
export const TRAVEL_SEARCH_IDENTIFIERS = 'identifier';
export const TRAVEL_SEARCH_PERSON_TYPES = 'personTypes';
export const TRAVEL_SEARCH_AIRPORT_ID = 'airportId';
export const TRAVEL_SEARCH_PERSON_CUSTOM_FIELDS = 'customFields';
export const TRAVEL_SEARCH_TRIP_CUSTOM_FIELDS = 'itineraryCustomFields';
export const TRAVEl_SEARCH_RAILWAY = 'railwayNameLike';
export const TRAVEl_SEARCH_TRAIN_NUMBER = 'trainNumberLike';

export const TRAVEL_SEARCH_ITINERARY_DELETED_STATUSES = {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
};

export const TRAVEL_SEARCH_SERVICE_KEYS = {
  DATE_FILTER_TYPE: {
    TRAVEL: 'BUFFERED_PERSON_LOCATION',
    TRAVEL_CREATED: 'TRAVEL_CREATED',
    TRAVEL_LAST_UPDATED: 'TRAVEL_LAST_UPDATED',
    TRAVEL_CREATED_OR_LAST_UPDATED: 'TRAVEL_CREATED_OR_LAST_UPDATED',
  },
};

export const TRAVEL_SEARCH_DESTINATION_TYPE_VALUES = {
  DOMESTIC: 'DOMESTIC',
  INTERNATIONAL: 'INTERNATIONAL',
  ALL: 'ALL',
};

export const TRAVEL_SEARCH_KEYWORD_MINIMUM_LENGTH = 3;
